import * as React from 'react';

import Tooltip from '@material-ui/core/Tooltip';

interface Props {
  children: React.ReactElement;
  currentEvent?: string;
  title: string;
}
const TooltipItem = (props: Props) => {
  return (
    // @ts-ignore
    <Tooltip
      interactive
      title={props.title}
      placement='top'>
      {/*  @ts-ignore */}
      {props.children}
    </Tooltip>
  );
};

export default TooltipItem;
